import { Injectable } from '@angular/core';
import { SalesOrg, SoldTo } from '../../../core/model';
import { Occ } from '../../../core/occ/occ-models';
import { Converter } from '../../../core/util';

@Injectable({ providedIn: 'root' })
export class SoldToNormalizer implements Converter<Occ.SoldTo, SoldTo> {
  convert(source: Occ.SoldTo, target?: SoldTo): SoldTo {
    if (source) {
      target = this.convertSoldTo(source);
    }

    return target;
  }

  private convertSoldTo(source: Occ.SoldTo): SoldTo {
    if (source) {
      const { shipTo, salesOrg, ...target } = source;
      return {
        ...target,
        defaultShipTo: shipTo,
        salesOrg: this.convertSalesOrg(source.salesOrg),
      };
    } else {
      return undefined;
    }
  }

  private convertSalesOrg(source: Occ.SalesOrg): SalesOrg {
    return source
      ? {
          ...source,
          uid: source.code,
        }
      : undefined;
  }
}
